import React from "react";
import "../../Assets/css/HealthQuickQuote.css";
import "../../Assets/css/globalStyle.css";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import useQuickQuote from "./useQuickQuote";
import { ErrorMessage, Field, Form, Formik } from "formik";
import TextError from "../../Components/HealthInsFormikComponent/TextError";
import InsuredsFieldArray from "../../Components/PersonalAccidentComponents/InsuredsFieldArray/InsuredsFieldArray";
import { Typography } from "@mui/material";
import getInputFieldBorderClassName from "./Helpers/getInputFieldBorderClassName";
import { occupationListForInsureds } from "./Helpers/constants";
import ButtonGroupFooter from "../../Components/PersonalAccidentComponents/ButtonGroupFooter/ButtonGroupFooter";
import CircularProgressBar, {
  CircularProgressSize,
} from "../../Components/PersonalAccidentComponents/CircularProgressBar/CircularProgressBar";

export default function QuickQuote() {
  // Calling useQuickQuote hooks to get initial values, validation schema and on submit
  const { initialValues, validationSchema, onSubmit, initialLoading } =
    useQuickQuote();

  return (
    <div className="bg-white QQ_container">
      {/* Category Header */}
      <CategoryHeader title="Personal Accident Insurance" />
      {/* Form */}
      <div>
        {!initialLoading ? (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
              <Form>
                {console.log("formik", formik)}
                <div className="form-container">
                  <Typography variant="h5" className="fw-bold HQ-title">
                    Tell us about yourself
                  </Typography>

                  {/* Proposer Name layout */}
                  <ProposerNameLayout formik={formik} />

                  {/* Layout to select gender */}
                  <GenderSelectLayout />

                  {/* Occupation drop down layout */}
                  <OccupationSelectLayout formik={formik} />

                  {/* Annual Income layout */}
                  <AnnualIncomeLayout formik={formik} />

                  {/* Sum insured layout */}
                  <SumInsuredSelectLayout formik={formik} />

                  {/* Array of Insureds input fields */}
                  <InsuredsFieldArray formik={formik} />
                </div>

                {/* Reset and Submit buttons with circular progress indicator */}
                <ButtonGroupFooter
                  isLoading={formik.isSubmitting}
                  leftButtonType="reset"
                  leftButtonText="Reset"
                />
              </Form>
            )}
          </Formik>
        ) : (
          <CircularProgressBar size={CircularProgressSize.large} />
        )}
      </div>
    </div>
  );
}

const ProposerNameLayout = ({ formik }) => {
  return (
    <div className="form-group mb-3" style={{ paddingTop: "20px" }}>
      <Typography
        htmlFor="proposer_first_name"
        variant="body1"
        className="fw-light"
        style={{ paddingBottom: "8px" }}
      >
        First Name
      </Typography>
      <div className="input-icons">
        <Field
          type="text"
          name="proposer_first_name"
          id="proposer_first_name"
          className={getInputFieldBorderClassName(
            formik,
            "proposer_first_name"
          )}
        />
      </div>
      <ErrorMessage name="proposer_first_name" component={TextError} />
    </div>
  );
};

const GenderSelectLayout = () => {
  return (
    <div className="d-flex flex-nowrap justify-content-center bd-highlight mb-4">
      <div>
        <div className="maleRadioGroup">
          <div className="radioGroupBelow">
            <label htmlFor="maleGender">
              <Field type="radio" name="gender" value="Male" id="maleGender" />
              <span>Male</span>
            </label>
          </div>
        </div>

        <div className="femaleRadioGroup">
          <div className="radioGroupBelow">
            <label htmlFor="maleGender">
              <Field
                type="radio"
                name="gender"
                value="Female"
                id="maleGender"
              />
              Female
            </label>
          </div>
        </div>

        <div className="transgenderRadioGroup">
          <div className="radioGroupBelow">
            <label htmlFor="transGender">
              <Field
                type="radio"
                name="gender"
                value="Transgender"
                id="transgender"
              />
              Other
            </label>
          </div>
        </div>
        <ErrorMessage name="gender" component={TextError} />
      </div>
    </div>
  );
};

const OccupationSelectLayout = ({ formik }) => {
  return (
    <div className="form-group mb-3 ">
      <Typography htmlFor="proposer_occupation" variant="body1">
        Occupation
      </Typography>
      <Field
        as="select"
        name="proposer_occupation"
        id="proposer_occupation"
        className={getInputFieldBorderClassName(formik, "proposer_occupation")}
      >
        <option value="">Select Occupation</option>
        {occupationListForInsureds.map((item) => (
          <option key={item.id} value={item.id}>
            {item.value}
          </option>
        ))}
      </Field>
      <ErrorMessage name="proposer_occupation" component={TextError} />
    </div>
  );
};

const SumInsuredSelectLayout = ({ formik }) => {
  return (
    <div className="mb-4 ">
      <Typography htmlFor="proposer_sum_insured" variant="body1">
        Sum Assured
      </Typography>
      <Field
        type="number"
        name="proposer_sum_insured"
        id="proposer_sum_insured"
        className={getInputFieldBorderClassName(formik, "proposer_sum_insured")}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        onWheel={(e) => e.currentTarget.blur()}
      />
      <ErrorMessage name="proposer_sum_insured" component={TextError} />
    </div>
  );
};

const AnnualIncomeLayout = ({ formik }) => {
  return (
    <div className="form-group mb-3 ">
      <Typography
        htmlFor="proposer_annual_income"
        variant="body1"
        className="fw-light"
      >
        Annual Income
      </Typography>
      <div className="input-icons">
        <Field
          type="number"
          name="proposer_annual_income"
          id="proposer_annual_income"
          className={getInputFieldBorderClassName(
            formik,
            "proposer_annual_income"
          )}
          aria-describedby="nameHelp"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          onWheel={(e) => e.currentTarget.blur()}
        />
      </div>
      <ErrorMessage name="proposer_annual_income" component={TextError} />
    </div>
  );
};
